import { createAsyncThunk , createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { config,baseUrl } from "../../utils/baseUrl";

export const fectchEventDetailsAction = createAsyncThunk('Allevents/details',async(payload,{rejectWithValue , getState, dispatch})=>{
    try {
        const {data} = await axios.get(`${baseUrl}/api/event/fetchEventDetails`,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const fetchEventDataAction = createAsyncThunk('event/data',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            teamId : payload?.teamId,
            userId : payload?.userId,
            eventId : payload.id,
        }

        const {data} = await axios.post(`${baseUrl}/api/event/alldetails`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const eventmessageDeleteAction = createAsyncThunk('message/delete',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        // Delete message;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const eventRegistrationAction = createAsyncThunk('event/registration',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
            eventId : payload.eventId,
        }

        const {data} = await axios.put(`${baseUrl}/api/event/register`,sendData,config);

        return data;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

const eventSlice = createSlice({
    name : "Event",

    initialState : {
        time : "present",
    },

    extraReducers : (builder)=>{
        //all events
        builder.addCase(fectchEventDetailsAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(fectchEventDetailsAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.pastEvents = action?.payload?.pastEvents;
            state.futureEvents = action?.payload?.futureEvents;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(fectchEventDetailsAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //event data
        builder.addCase(fetchEventDataAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(fetchEventDataAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.event = action?.payload?.event;
            state.time = action?.payload?.time;
            state.registered = action?.payload?.registered;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(fetchEventDataAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });


        //Event register
        builder.addCase(eventRegistrationAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(eventRegistrationAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.message = action?.payload?.message;
            state.registered = action?.payload?.registered;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(eventRegistrationAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });


        //Delete message
        builder.addCase(eventmessageDeleteAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(eventmessageDeleteAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.message = null;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(eventmessageDeleteAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = null;
            state.serveError = null;
        });

    } 

});

export default eventSlice.reducer;